import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Dialog from '../../common/Dialog';
import InputText from '../../common/Form';
import { Box } from '@mui/material';
import { newBudget } from '../../../store/actions/categoriesAction'

class BudgetForm extends Component {
    state = { 
        budget_max: this.props.budget.budget_max ? this.props.budget.budget_max : 0,
        subCat: this.props.budget.subCat ? this.props.budget.subCat : {
            // catID: budgetMax
        },
        errors:{
            budget_max: "",
        }
    }
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        if (name === "budget_max") {
            this.setState({
                [name]: value
            })
        } else {
            let newSub = Object.assign({}, this.state.subCat)
            newSub[name] = value
            this.setState({
                subCat: newSub
            })
        }
    }
    validate = () => {
        let required = [
            "budget_max",
        ]
        
        let noError = true
        let errors = {}

        required.map(field => {
            if(!this.state[field]){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
        let total = 0
        Object.values(this.state.subCat).forEach( budget => {
            total += parseFloat(budget)
        })
    
        if (total > this.state.budget_max) {
            noError =  false
            errors.budget_max = "Le budget de la catégorie principale ne peut être inférieur au total des sous catégories" 
        }
        this.setState({
            errors
        })
        return noError
    }

    handleSubmit = async () => {
        if(this.validate()){
            const { subCat, budget_max} = this.state;
            let data = Object.assign({}, this.props.budget)
            data.budget_max = parseFloat(budget_max)
            data.subs = []
            Object.keys(subCat).forEach( cat => {
                if (parseFloat(subCat[cat]) > 0 ) {
                    let tmp = {
                        category_id: cat,
                        budget_max: parseFloat(subCat[cat]),
                        // catgory_parent: data.category_id, ADD IN BACK
                        // budget_year: data.budget_year, ADD IN BACK
                    }
                    data.subs.push(tmp)
                }
            })
            // data.budget_year = parseInt(this.props.budget_year)
            // delete data.budget_spent
            console.log('====================================');
            console.log({data});
            console.log('====================================');

            await this.props.newBudget(data)
            // await this.props.updateCategory(data)
            
            if(this.props.STATE.budgets.error){
                console.log('====================================');
                console.log("ERROR", this.props.STATE.budgets );
                console.log('====================================');
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.budgets.error}`)
            } else {
                this.props.update && this.props.notif("success","Le budget a été modifiée avec succès")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs" )
        }
    }
    render() {
        // console.log('====================================');
        // console.log(this.props);
        // console.log('====================================');
        const { CATEGORIES, category } = this.props;
        return (
            <Dialog
                close={this.props.handleClose}
                appBar
                title={category.category_name}
                submitAction={this.handleSubmit} 
                disabledSubmit={this.props.STATE.categories.fetching}
            >
                <InputText
                    required
                    type="number"
                    name="budget_max" 
                    id="budget_max" 
                    value={this.state.budget_max} 
                    label="Budget Total" 
                    error={this.state.errors.budget_max} 
                    onChange={this.handleChange}
                />
                {CATEGORIES && CATEGORIES.LIST[category.category_id] && CATEGORIES.LIST[category.category_id].map(catChild => (
                    <Box p={2}>
                        <InputText
                            // required
                            type="number"
                            name={catChild} 
                            id={catChild} 
                            value={this.state.subCat[catChild] || this.props.BUDGETS[catChild]} 
                            label={CATEGORIES.CHILD[catChild].category_name} 
                            onChange={this.handleChange}
                        />
                    </Box>
                ))
                }
                    
            </Dialog>

        );
    }
}
function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        BUDGETS: state.budgets,
        STATE: state.request,
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        newBudget,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BudgetForm);

